var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page flex-col",
    staticStyle: {
      heignt: "100%",
      overflow: "auto"
    }
  }, [_c("div", {
    staticClass: "outer1 flex-col"
  }, [_c("div", {
    staticClass: "bd2 flex-row justify-between"
  }, [_c("div", {
    staticClass: "group1 flex-col",
    staticStyle: {
      "margin-top": "5vw",
      "margin-left": "8vw",
      height: "10vw"
    },
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    staticStyle: {
      height: "4vw",
      width: "3vw"
    },
    attrs: {
      src: require("../../assets/images/back.png"),
      alt: ""
    }
  })])]), _c("div", {
    staticClass: "pdf-box"
  }, _vm._l(_vm.numPages, function (i) {
    return _c("pdf", {
      key: i,
      attrs: {
        src: _vm.pdfSrc,
        page: i
      }
    });
  }), 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };